<script setup lang="ts">
import CompactOrder from '@/components/CompactOrder/CompactOrder.vue';
import { Models, useContext, useOrderViewContext } from '@hantera/portal-app';


const orderViewContext = useOrderViewContext();
const context = useContext()

function openOrder(order: Models.Graph.Order) {
  context.openView('/order', {
    query: {
      id: order.orderNumber
    }
  })
}

</script>

<template>

  <div>
    <CompactOrder
      v-for="order in orderViewContext.state.customer?.orders"
      :key="order.orderId"
      :order="order"
      v-on="order.orderId !== orderViewContext.state.orderId ? { click: openOrder } : {}"
    />
  </div>

</template>